import React from 'react';

const YoutubeIcon: React.FC = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="youtube-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="12">
        <path
          d="M15.67 2.33291C15.4855 1.64759 14.9452 1.10724 14.2598 0.922736C13.0078 0.580078 7.99974 0.580078 7.99974 0.580078C7.99974 0.580078 2.99167 0.580078 1.73965 0.909557C1.06751 1.09407 0.513987 1.64759 0.329479 2.33291C0 3.58493 0 6.18122 0 6.18122C0 6.18122 0 8.79069 0.329479 10.0295C0.513987 10.7149 1.05433 11.2552 1.73965 11.4397C3.00485 11.7824 7.99974 11.7824 7.99974 11.7824C7.99974 11.7824 13.0078 11.7824 14.2598 11.4529C14.9452 11.2684 15.4855 10.728 15.67 10.0427C15.9995 8.79069 15.9995 6.1944 15.9995 6.1944C15.9995 6.1944 16.0127 3.58493 15.67 2.33291Z"
          fill="white"
        />
        <path d="M6.40625 8.58041L10.5709 6.1818L6.40625 3.7832V8.58041Z" fill="black" />
      </mask>
      <rect width="16" height="12" fill="currentColor" mask="url(#youtube-mask)" />
    </svg>
  );
};

export default YoutubeIcon;
